import React, { useReducer, createContext } from 'react';

import contextReducer from './contextReducer'; 

const initialState = JSON.parse(localStorage.getItem('transactions')) || [{"amount":100,"category":"Pets","type":"Expense","date":"2021-12-21","id":"5254410a-e4e9-4f47-838b-42f77247fe72"},{"amount":50,"category":"Travel","type":"Expense","date":"2021-12-23","id":"20784244-042e-47e7-b303-4af47fea0cb5"},{"amount":50,"category":"Business","type":"Income","date":"2021-12-27","id":"5d4b5347-4134-4077-9dde-6c919d895b08"},{"amount":100,"category":"Salary","type":"Income","date":"2021-12-23","id":"d6939c5a-334e-442e-af27-aece547e8c11"}];

export const ExpenseTrackerContext = createContext(initialState);

export const Provider = ({ children }) => {

    const [transactions, dispatch] = useReducer(contextReducer, initialState);

    // Actions Creators
    const deleteTransaction = (id) => {
        dispatch({ type: 'DELETE_TRANSACTION', payload: id })
    }

    const addTransaction = (transaction) => {
        dispatch({ type: 'ADD_TRANSACTION', payload: transaction })
    }

    const balance = transactions.reduce((acc, currVal) => {
        return (currVal.type === 'Expense' ? acc - currVal.amount : acc + currVal.amount)
    }, 0)

    // console.log(transactions);

    return (
        <ExpenseTrackerContext.Provider
            value={{
                deleteTransaction,
                addTransaction,
                transactions,
                balance
            }}
        >
            {children}
        </ExpenseTrackerContext.Provider>
    )
}